import { Component, Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { BaseRoute } from '../../../shared/components/base.route';
import { FlowManagerService } from '../../../shared/services/flowmanager.service';
import { ModalService } from '../../../shared/services/modal.service';
import { QuestionnaireService } from '../../../shared/services/questionnaire.service';

import { GoalSession } from '../../../shared/models/Recommendation/RecommendationInterfaces';

@Component({
  selector: 'explore-other-options',
  template: require('./explore-other-options.component.html'),
  styles: [require('./explore-other-options.component.scss')]
})
export class ExploreOtherOptionsComponent extends BaseRoute {
  exploreOtherOptions$: Observable<any>;
  subscriptions$: Subscription = new Subscription();
  options = {
    attr: { id: 'exploreOtherOptions' },
    inputType: 'radioCard',
    inputPath: 'goalSession.userPortfolioSelection',
    label: 'Portfolio',
    msg: {
      fail: 'Make a selection to continue'
    }
  };
  originalGoalSession: GoalSession;
  /**
   * Flag used to determine whether or not to reset goal session
   * when component is destroyed.
  */
  doNotReset: boolean = false;

  constructor(injector: Injector,
    questionnaire: QuestionnaireService,
    flowManager: FlowManagerService,
    modal: ModalService) {
    super(injector);
    this.questionnaire = questionnaire;
    this.flowManager = flowManager;
    this.modal = modal;
  }

  ngOnInit() {
    this.questionnaire.updatePortfolio();

    // Copy original goalSession
    this.originalGoalSession = { ...this.flowManager.goalSession };

    // Set isUserSelectedPortfolio = null or some other variable
    // This value is set by the confirmation modal (recommendation-disclaimer-modal)
    // Start off as null but set to true if user confirms their portfolio change
    // Not a good way to communicate between things but couldn't get callback to work correctly
    this.flowManager.goalSession = { ...this.flowManager.goalSession, isUserSelectedPortfolio: null };

    // Copy recommended into user Selected ONLY if it doesn't already exist
    // If a user navigated to this page and chose a new portfolio then we should not
    // reset it back to the recommended.
    // If the user switches strategies then this value needs to be reset
    // Note switch strategy here means from Core to SRI, or SRI to Tax Optimized
    // Switching from Core to Fully Vested Core and vice versa should not reset this value
    if (!this.flowManager.goalSession.userPortfolioSelection) {
      this.flowManager.goalSession = {
        ...this.flowManager.goalSession,
        userPortfolioSelection: +this.flowManager.goalSession.portfolioTier
      };
    }

    this.exploreOtherOptions$ = this.questionnaire.exploreOtherOptions$;

    this.subscriptions$.add(
      this.exploreOtherOptions$
        .subscribe(x => {
          if (x) {
            this.options.options = x;
          }
        })
    );
  }

  selectOptionValue(event) { }

  onUpdate() {
    const nothingChanged = [+this.originalGoalSession.userPortfolioSelection,
    +this.originalGoalSession.portfolioTier];
    // If nothing changed then redirect to recommendation
    // 1. If user selected a model portfolio tier that matches recommendedModelPortfolioTier
    // in the original goal session. It's a special case. You chose what we recommended so we
    // shouldn't pop up a modal saying you're picking outside our recommendation.
    // 2. If user selected portfolio matches original goal session user selected portfolio
    if (nothingChanged.includes(+this.flowManager.goalSession.userPortfolioSelection)) {
      this.doNotReset = true;
      this.router.navigate(['/recommendation'], { queryParamsHandling: 'preserve' });
    } else {
      this.modal.generic({ modalType: 'recommendationDisclaimer' });
    }
  }

  ngOnDestroy() {
    this.subscriptions$.unsubscribe();
    // If the user has not confirmed their portfolio via the modal then reset this selection
    // but if they are picking what we recommended then do not reset
    // Same idea as note (1) in onUpdate but extra logic to account for it

    // The user did not confirm via modal AND
    // stuff has changed and the user did not click update button
    if (!this.flowManager.goalSession.isUserSelectedPortfolio
      && this.doNotReset === false) {
      this.resetGoalSessionChanges();
    }

  }

  resetGoalSessionChanges() {
    this.flowManager.goalSession = { ...this.originalGoalSession };
  }
}
